module.exports = __webpack_public_path__ + "assets/icon_bonus_highlight.25f5a0df.svg";